import { render, staticRenderFns } from "./DeleteGSheetKBModal.vue?vue&type=template&id=78b8a7fc&"
import script from "./DeleteGSheetKBModal.vue?vue&type=script&lang=js&"
export * from "./DeleteGSheetKBModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b8a7fc')) {
      api.createRecord('78b8a7fc', component.options)
    } else {
      api.reload('78b8a7fc', component.options)
    }
    module.hot.accept("./DeleteGSheetKBModal.vue?vue&type=template&id=78b8a7fc&", function () {
      api.rerender('78b8a7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/components/DeleteGSheetKBModal.vue"
export default component.exports